var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm._m(0)
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("section", { attrs: { id: "registry-view" } }, [
      _c("h2", [_vm._v("Our Registry")]),
      _vm._v(" "),
      _c("ul", { staticClass: "stores" }, [
        _c("li", [
          _c(
            "a",
            {
              attrs: {
                href: "http://tgt.gifts/maggiandjordan",
                target: "_blank"
              }
            },
            [
              _c("img", {
                attrs: { src: "images/target-logo.jpg", alt: "Target" }
              })
            ]
          )
        ]),
        _vm._v(" "),
        _c("li", [
          _c(
            "a",
            {
              attrs: {
                href:
                  "https://www.westelm.com/registry/vxdg2sclq6/registry-list.html",
                target: "_blank"
              }
            },
            [
              _c("img", {
                attrs: { src: "images/west-elm.png", alt: "West Elm" }
              })
            ]
          )
        ])
      ])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-2b0df496", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2b0df496","hasScoped":false,"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0&bustCache!./src/views/registries.vue
// module id = 65
// module chunks = 0